import _slicedToArray from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\@vue\\babel-preset-app\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\@vue\\babel-preset-app\\node_modules\\core-js\\modules\\es.promise.js";
import "D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\@vue\\babel-preset-app\\node_modules\\core-js\\modules\\es.object.assign.js";
import "D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\@vue\\babel-preset-app\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.filter.js";
/* eslint-disable */
import Vue from 'vue';
import 'normalize.css/normalize.css'; // A modern alternative to CSS resets
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/zh-CN'; // lang i18n
import '@/styles/index.scss'; // global css
import '@/styles/main.scss'; // global css
import '@/styles/element-variables.scss';
import App from './App';
import store from './store';
import router from './router';
import axios from 'axios';
import commonUI from 'hexasino-common-ui-vue';
import '@/icons'; // icon
import '@/permission'; // permission control
import VueI18n from 'vue-i18n';
import API from './api';
import lodash from 'lodash';
import * as filters from './utils/filters';
import '@/utils/directives.js';
import { interceptors } from '@/utils/interceptors';
import '@/utils/postMessage';
import BreadCrumb from '@/utils/setComponents';
import svgInstall from '@/utils/svgInstall';
import VueXss from 'vue-xss';
import VueSSE from 'vue-sse';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

// using defaults
Vue.use(VueSSE);
Vue.use(VueXss, {
  whiteList: {
    span: ['style'],
    del: ['style'],
    ins: ['style'],
    br: []
  }
});
Vue.use(svgInstall);
Vue.use(BreadCrumb);
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  // 2022-07-25 去除mockjs,原因：与el-upload组件有冲突，production环境无法触发on-progress回调，详情请看https://github.com/PanJiaChen/vue-element-admin/issues/445
  // const { mockXHR } = require('../mock')
  // mockXHR()
}
interceptors(axios, store, router, {
  refreshToken: 'user/refreshToken',
  filtersUrl: ['oauth/refreshToken']
});
var theme = process.env.VUE_APP_theme;
document.getElementsByTagName('body')[0].classList.add(theme);
Vue.use(VueAwesomeSwiper);
Vue.use(VueI18n);
Vue.use(commonUI);
var i18n = new VueI18n({
  locale: 'zh',
  // 语言标识
  // this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    zh: require('./lang/zh'),
    // 中文语言包
    en: require('./lang/en') // 英文语言包
  }
});

// 全局修改默认配置，点击空白处不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false;
// set ElementUI lang to EN
Vue.use(ElementUI, {
  locale: locale,
  size: 'small'
});

// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

Vue.config.productionTip = false;
Vue.prototype.$API = API;
Vue.prototype.$lodash = lodash;
// 全局过滤器
Object.entries(filters).forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    value = _ref2[1];
  Vue.filter(key, value);
});
Vue.prototype.$EventBus = new Vue({
  el: '#app',
  i18n: i18n,
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
});